import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../../constants/form'

export const QA_NAME_EDIT_MANAGERS_MODAL = 'editManagers'

export const BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS = 'responsible_users'

export const BUILDING_EDIT_MANAGERS_FORM_BODY_PROPS = {
  ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
  validationErrorsNotificationProps: {
    ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION.validationErrorsNotificationProps,
    responsibleManagersFieldName: BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS,
  },
}
